import {
  Flex,
  Text,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Switch,
  Stack,
  Grid,
  Select,
  Box,
  Tab,
  TabList,
  Tabs,
  TabPanel,
  TabPanels,
} from '@chakra-ui/react';
import { parseISO } from 'date-fns';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import SearchTable2 from 'components/Tables/SearchTable2';
import React, { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { totalRow } from 'state/roles-permissions';
import { AddIcon } from '@chakra-ui/icons';
import { checkForbidden } from 'helpers/checkForbidden';
import { useCMSActions } from 'hooks/useCMS';
import Editor from 'components/Editor/Editor2';
import DatePickerInput from 'components/CustomDateInput/CustomDateInput';
import { useRatePlanActions } from 'hooks/useRatePlanActions';
import { columnsDataRecruitment } from 'variables/columnsData';
import { recruitmentAtom, locationWebAtom } from 'state/cms';
import dayjs from 'dayjs';
import { RxReset } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { STATUS, EMPLOYMENT_TYPE } from 'variables/general';
import { findValue } from 'helpers/helpers';

function DataTableRecruitment() {
  const textColor = useColorModeValue('gray.700', 'white');
  const listNews = useRecoilValue(recruitmentAtom);
  const totalRows = useRecoilValue(totalRow);
  const listLocationWeb = useRecoilValue(locationWebAtom);
  const setRecruitmentAtom = useSetRecoilState(recruitmentAtom);
  const setTotalRows = useSetRecoilState(totalRow);

  const cmsActions = useCMSActions();
  const ratePlanActions = useRatePlanActions();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCreate, setIsCreate] = useState(true);
  const [currentNewsID, setCurrentNewsID] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [newListNews, setNewListNews] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewImageVN, setPreviewImageVN] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [refreshPagingDefault, setRefreshPagingDefault] = useState(false);
  const [languageIds, setLanguageIds] = useState({});

  const validationSchema = Yup.object().shape({
    position: Yup.string().required('This field is required'),
    posting_date: Yup.date().nullable().required('This field is required'),
    closing_date: Yup.date().nullable().required('This field is required'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    formState,
    reset,
    setValue,
    control,
    watch,
  } = useForm(formOptions);
  const { errors, isSubmitting } = formState;
  const toast = useToast();
  const imageURL = watch('file_url');
  const imageURLVN = watch('file_url_vn');

  // Search form
  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    control: controlSearch,
    watch: watchSearch,
    reset: resetSearch,
  } = useForm();
  useEffect(() => {
    cmsActions.getListLocations({status: 1});
    // Load data mặc định khi vào trang
    const loadInitialData = async () => {
      let pageSize = 10;
      try {
        const s = localStorage && localStorage.getItem('currentPageSizeStore');
        if (s) pageSize = parseInt(s, 10) || 10;
      } catch (e) {}

      setIsFetching(true);
      await cmsActions.getListRecruitment(
        {
          status: undefined, // All status
          sort_type: '',
          sort_field: '',
          offset: 0,
          limit: pageSize,
        },
        0,
        pageSize
      );
      setIsFetching(false);
      setHasSearched(true); // Đánh dấu đã có data để pagination hoạt động
    };

    loadInitialData();
  }, []);

  useEffect(async () => {
    if (imageURL && imageURL?.length > 0) {
      const formData = new FormData();
      formData.append('file', imageURL[0]);
      const {
        data: { data },
      } = await ratePlanActions.uploadImageRatePlanConfig(formData);
      setPreviewImage(data.url);
    }
  }, [imageURL]);

  useEffect(async () => {
    if (imageURLVN && imageURLVN?.length > 0) {
      const formData = new FormData();
      formData.append('file', imageURLVN[0]);
      const {
        data: { data },
      } = await ratePlanActions.uploadImageRatePlanConfig(formData);
      setPreviewImageVN(data.url);
    }
  }, [imageURLVN]);

  useEffect(() => {
    if (listNews) {
      const toolTypes = listNews.map((i) => {
        const location = listLocationWeb.find(loc => loc.id === i.location_id);
        return {
          ...i,
          location_name: location ? location.name : '',
          filters: {
            position: watchSearch('positionSearch') || undefined,
            employment_type: watchSearch('employmentTypeSearch') || undefined,
            location_id: watchSearch('locationSearch') || undefined,
            posting_date_from: watchSearch('posting_date_from')
              ? dayjs(watchSearch('posting_date_from')).format('YYYY-MM-DD')
              : undefined,
            posting_date_to: watchSearch('posting_date_to')
              ? dayjs(watchSearch('posting_date_to')).format('YYYY-MM-DD')
              : undefined,
            closing_date_from: watchSearch('closing_date_from')
              ? dayjs(watchSearch('closing_date_from')).format('YYYY-MM-DD')
              : undefined,
            closing_date_to: watchSearch('closing_date_to')
              ? dayjs(watchSearch('closing_date_to')).format('YYYY-MM-DD')
              : undefined,
            status: watchSearch('statusSearch') || undefined,
          },
          typeSwitch: 'recruitment',
        };
      });
      setNewListNews(toolTypes);
    }
  }, [
    listNews,
    listLocationWeb,
    watchSearch('positionSearch'),
    watchSearch('employmentTypeSearch'),
    watchSearch('locationSearch'),
    watchSearch('posting_date_from'),
    watchSearch('posting_date_to'),
    watchSearch('closing_date_from'),
    watchSearch('closing_date_to'),
    watchSearch('statusSearch'),
  ]);

  const onSubmitSearch = async (formValues) => {
    let pageSize = 10;
    try {
      const s = localStorage && localStorage.getItem('currentPageSizeStore');
      if (s) pageSize = parseInt(s, 10) || 10;
    } catch (e) {}
    setRefreshPagingDefault((v) => !v);
    recallApi({ pageIndex: 0, pageSize }, true);
  };

  const recallApi = async (fetchDataOptions, isFromSearch) => {
    setIsFetching(true);
    const pageIndex = fetchDataOptions?.pageIndex ?? 0;
    const pageSize = fetchDataOptions?.pageSize ?? 10;
    const params = {
      position: watchSearch('positionSearch') || undefined,
      employment_type: watchSearch('employmentTypeSearch') || undefined,
      location_id: watchSearch('locationSearch') || undefined,
      posting_date_from: watchSearch('posting_date_from')
        ? new Date(new Date(watchSearch('posting_date_from')).setHours(0, 0, 0, 0)).toISOString()
        : undefined,
      posting_date_to: watchSearch('posting_date_to')
        ? new Date(new Date(watchSearch('posting_date_to')).setHours(23, 59, 59, 999)).toISOString()
        : undefined,
      closing_date_from: watchSearch('closing_date_from')
        ? new Date(new Date(watchSearch('closing_date_from')).setHours(0, 0, 0, 0)).toISOString()
        : undefined,
      closing_date_to: watchSearch('closing_date_to')
        ? new Date(new Date(watchSearch('closing_date_to')).setHours(23, 59, 59, 999)).toISOString()
        : undefined,
      status: watchSearch('statusSearch') || undefined,
      sort_type: fetchDataOptions?.sort_type || '',
      sort_field: fetchDataOptions?.sort_field || '',
      offset: pageIndex * pageSize,
      limit: pageSize,
    };

    if (hasSearched || isFromSearch) {
      await cmsActions.getListRecruitment(params, pageIndex, pageSize);
    }
    setIsFetching(false);
    if (isFromSearch) {
      setHasSearched(true);
    }
  };
  async function onSubmit({
    position,
    description,
    id,
    status,
    posting_date,
    closing_date,
    isActive,
    responsibilities,
    requirements,
    location_id,
    employment_type,
    summary,
  }) {
    const params = {
      position,
      description,
      id,
      file_url: previewImage,
      status,
      posting_date,
      closing_date,
      status: isActive ? 1 : 2,
      responsibilities,
      requirements,
      location_id: parseInt(location_id),
      employment_type: parseInt(employment_type),
      summary,
    };

    // Xử lý đa ngôn ngữ (Vietnamese)
    const listKeys = [
      'position',
      'description',
      'responsibilities',
      'requirements',
      'file_url',
      'summary',
    ];
    const languages = listKeys
      .map((i) => {
        const value = i === 'file_url' ? previewImageVN : watch(`${i}_vn`);

        // Nếu field trống và trước đó chưa từng có locale này thì bỏ qua
        if (!value && !(!isCreate && languageIds[i])) {
          return undefined;
        }

        const languageItem = {
          code: 'vi',
          locale_key: i,
          locale_value: value || '',
        };

        // Nếu đang update và có id của locale_key này, truyền id xuống
        if (!isCreate && languageIds[i]) {
          languageItem.id = languageIds[i];
        }

        return languageItem;
      })
      .filter(Boolean);
    params.languages = languages;

    try {
      let res;
      if (isCreate) {
        res = await cmsActions.createRecruitment(params);
      } else {
        res = await cmsActions.updateRecruitment(params, currentNewsID);
      }

      if (res.status === 200) {
        onClose();
        reset();
        setPreviewImage('');
        setPreviewImageVN('');
        setLanguageIds({});
        const message = isCreate
          ? 'Create Recruitment success'
          : 'Update Recruitment success';
        toast({
          description: message,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });

        // Reload với filter/search hiện tại
        let pageSize = 10;
        try {
          const s = localStorage && localStorage.getItem('currentPageSizeStore');
          if (s) pageSize = parseInt(s, 10) || 10;
        } catch (e) {}

        const params = {
          position: watchSearch('positionSearch') || undefined,
          employment_type: watchSearch('employmentTypeSearch') || undefined,
          location_id: watchSearch('locationSearch') || undefined,
          posting_date_from: watchSearch('posting_date_from')
            ? new Date(new Date(watchSearch('posting_date_from')).setHours(0, 0, 0, 0)).toISOString()
            : undefined,
          posting_date_to: watchSearch('posting_date_to')
            ? new Date(new Date(watchSearch('posting_date_to')).setHours(23, 59, 59, 999)).toISOString()
            : undefined,
          closing_date_from: watchSearch('closing_date_from')
            ? new Date(new Date(watchSearch('closing_date_from')).setHours(0, 0, 0, 0)).toISOString()
            : undefined,
          closing_date_to: watchSearch('closing_date_to')
            ? new Date(new Date(watchSearch('closing_date_to')).setHours(23, 59, 59, 999)).toISOString()
            : undefined,
          status: watchSearch('statusSearch') || undefined,
          sort_type: '',
          sort_field: '',
          offset: 0,
          limit: pageSize,
        };

        await cmsActions.getListRecruitment(params, 0, pageSize);
      }
    } catch (err) {
      console.warn(err);
      toast({
        description: err?.response?.data?.meta?.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  async function editNews(newsID) {
    reset();
    const newsData = await cmsActions.getDetailRecruitment(newsID);
    if (newsData) {
      const {
        position,
        description,
        id,
        file_url,
        status,
        posting_date,
        closing_date,
        responsibilities,
        requirements,
        location_id,
        employment_type,
        summary,
        languages,
      } = newsData.data.data;

      setIsCreate(false);
      setCurrentNewsID(id);
      onOpen();

      // Set values after modal opens to avoid CKEditor errors
      setTimeout(() => {
        setValue('position', position);
        setValue('description', description || '');
        setValue('responsibilities', responsibilities || '');
        setValue('requirements', requirements || '');
        setValue('location_id', location_id);
        setValue('employment_type', employment_type || 1);
        setValue('summary', summary || '');
        setPreviewImage(file_url);
        setValue('posting_date', parseISO(posting_date), 1);
        setValue('closing_date', parseISO(closing_date), 1);
        setValue('isActive', status === 1 ? true : false);

        // Load Vietnamese version data and store language IDs
        if (languages) {
          const ids = {};
          languages.forEach((e) => {
            // Store the ID for each locale_key
            ids[e.locale_key] = e.id;

            if (e.locale_key === 'file_url') return;
            setValue(`${e.locale_key}_vn`, e.locale_value || '');
          });
          setPreviewImageVN(findValue(languages, 'file_url'));
          setLanguageIds(ids);
        } else {
          setLanguageIds({});
        }
      }, 100);
    }
  }

  return (
    <Card px='0px'>
      <CardHeader px='22px' mb='12px'>
        <Flex direction='column' display='block'>
          <Text
            float='left'
            color={textColor}
            fontSize='lg'
            fontWeight='bold'
            mb='6px'
          >
            Recruitment Management
          </Text>
          <Stack float='right' direction='row' spacing={4}>
            {checkForbidden(42) && (
              <Button
                size='sm'
                onClick={() => {
                  reset();
                  setPreviewImage('');
                  setPreviewImageVN('');
                  setIsCreate(true);
                  setLanguageIds({});
                  setValue('description', '');
                  setValue('description_vn', '');
                  setValue('summary', '');
                  setValue('summary_vn', '');
                  setValue('responsibilities', '');
                  setValue('responsibilities_vn', '');
                  setValue('requirements', '');
                  setValue('requirements_vn', '');
                  setValue('employment_type', '1');
                  onOpen();
                }}
                leftIcon={<AddIcon />}
                colorScheme='blue'
                variant='outline'
              >
                Add Recruitment
              </Button>
            )}
          </Stack>
          {/* Search Form */}
          <Card mt={4}>
            <form
              id='recruitment-search-form'
              onSubmit={handleSubmitSearch(onSubmitSearch)}
            >
              <Flex
                direction='row'
                alignItems='center'
                mb={3}
                gap={4}
                flexWrap={'wrap'}
              >
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Position
                  </FormLabel>
                  <Input
                    ms='4px'
                    type='text'
                    size='sm'
                    placeholder='Search position'
                    name='positionSearch'
                    {...registerSearch('positionSearch')}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Employment Type
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='employmentTypeSearch'
                    {...registerSearch('employmentTypeSearch')}
                  >
                    {EMPLOYMENT_TYPE.map((item) => (
                      <option key={item.id} value={item.id === '0' ? '' : item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Location
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='locationSearch'
                    {...registerSearch('locationSearch')}
                  >
                    <option value=''>All</option>
                    {listLocationWeb.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Posting Date From
                  </FormLabel>
                  <Controller
                    name='posting_date_from'
                    control={controlSearch}
                    render={({ field }) => (
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        selected={watchSearch('posting_date_from')}
                        selectsStart
                        endDate={watchSearch('posting_date_to')}
                        minDate={new Date('01/01/2020')}
                        showTimeSelect={false}
                        dateFormat='dd/MM/yyyy'
                      />
                    )}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Posting Date To
                  </FormLabel>
                  <Controller
                    name='posting_date_to'
                    control={controlSearch}
                    render={({ field }) => (
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        selected={watchSearch('posting_date_to')}
                        selectsEnd
                        startDate={watchSearch('posting_date_from')}
                        minDate={watchSearch('posting_date_from')}
                        showTimeSelect={false}
                        dateFormat='dd/MM/yyyy'
                      />
                    )}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Closing Date From
                  </FormLabel>
                  <Controller
                    name='closing_date_from'
                    control={controlSearch}
                    render={({ field }) => (
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        selected={watchSearch('closing_date_from')}
                        selectsStart
                        endDate={watchSearch('closing_date_to')}
                        minDate={new Date('01/01/2020')}
                        showTimeSelect={false}
                        dateFormat='dd/MM/yyyy'
                      />
                    )}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Closing Date To
                  </FormLabel>
                  <Controller
                    name='closing_date_to'
                    control={controlSearch}
                    render={({ field }) => (
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        selected={watchSearch('closing_date_to')}
                        selectsEnd
                        startDate={watchSearch('closing_date_from')}
                        minDate={watchSearch('closing_date_from')}
                        showTimeSelect={false}
                        dateFormat='dd/MM/yyyy'
                      />
                    )}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Status
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='statusSearch'
                    {...registerSearch('statusSearch')}
                  >
                    {STATUS.map((item) => (
                      <option key={item.id} value={item.id === '0' ? '' : item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
              </Flex>
              <Flex justify='center' align='center' gap='8px' mt={3}>
                <Button
                  leftIcon={<RxReset />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  onClick={() => resetSearch()}
                >
                  Reset
                </Button>
                <Button
                  leftIcon={<BsSearch />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  type='submit'
                >
                  Search
                </Button>
              </Flex>
            </form>
          </Card>
          <Modal
            closeOnOverlayClick={false}
            trapFocus={false}
            isOpen={isOpen}
            onClose={() => {
              onClose();
              reset();
              setPreviewImage('');
              setPreviewImageVN('');
              setLanguageIds({});
            }}
            size='6xl'
          >
            <ModalOverlay />
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalContent>
                <ModalHeader>
                  {isCreate ? 'Add Recruitment' : 'Edit Recruitment'}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <Tabs isFitted variant='enclosed'>
                    <TabList>
                      <Tab
                        _focus={{ outline: 'none' }}
                        _selected={{ color: 'white', bg: 'blue.500' }}
                        fontWeight={'bold'}
                        fontSize={'18px'}
                      >
                        English
                      </Tab>
                      <Tab
                        _focus={{ outline: 'none' }}
                        _selected={{ color: 'white', bg: 'blue.500' }}
                        fontWeight={'bold'}
                        fontSize={'18px'}
                      >
                        Viet Nam
                      </Tab>
                    </TabList>

                    <TabPanels>
                      {/* English Tab */}
                      <TabPanel>
                        {/* Row 1: Position (full width) */}
                        <FormControl isRequired mt={2}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Position
                          </FormLabel>
                          <Input
                            fontSize='sm'
                            ms='4px'
                            type='text'
                            placeholder='Position'
                            maxLength={250}
                            size='md'
                            name='position'
                            {...register('position')}
                          />
                        </FormControl>

                        {/* Row 2: Location, Employment Type, File Upload */}
                        <Grid
                          templateColumns={{ sm: '1fr', md: 'repeat(3, 1fr)' }}
                          gap='12px'
                          mt={3}
                        >
                          <FormControl>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              Location
                            </FormLabel>
                            <Select
                              ms='4px'
                              type='text'
                              defaultValue='0'
                              size='sm'
                              name='location_id'
                              {...register('location_id')}
                            >
                              {listLocationWeb.map((i) => (
                                <option key={i.id} value={i.id}>
                                  {i.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              Employment Type
                            </FormLabel>
                            <Select
                              ms='4px'
                              type='text'
                              defaultValue='1'
                              size='sm'
                              name='employment_type'
                              {...register('employment_type')}
                            >
                              {EMPLOYMENT_TYPE.filter((item) => item.id !== '0').map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              File
                              {previewImage && (
                                <Text as='span' fontSize='xs' color='blue.500' ml={2}>
                                  <a
                                    href={previewImage}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{ textDecoration: 'underline' }}
                                  >
                                    (View current file)
                                  </a>
                                  {' | '}
                                  <Text
                                    as='span'
                                    color='red.500'
                                    cursor='pointer'
                                    textDecoration='underline'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setPreviewImage('');
                                      setValue('file_url', null);
                                    }}
                                  >
                                    Remove
                                  </Text>
                                </Text>
                              )}
                            </FormLabel>
                            <Input
                              fontSize='sm'
                              ms='4px'
                              type='file'
                              placeholder='File'
                              size='sm'
                              name='file_url'
                              {...register('file_url')}
                            />
                          </FormControl>
                        </Grid>

                        {/* Row 3: Posting Date, Closing Date */}
                        <Grid
                          templateColumns={{ sm: '1fr', md: 'repeat(2, 1fr)' }}
                          gap='12px'
                          mt={3}
                        >
                          <FormControl isRequired>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              Posting Date
                            </FormLabel>
                            <Controller
                              name='posting_date'
                              control={control}
                              render={({ field }) => (
                                <DatePickerInput
                                  onChange={(value) => field.onChange(value)}
                                  selected={watch('posting_date')}
                                  showTimeSelect
                                  startDate={watch('posting_date')}
                                  selectsStart
                                  endDate={watch('closing_date')}
                                />
                              )}
                            />
                            <Text color='red' fontSize={14} mb='10px' ml='5px'>
                              {errors.posting_date?.message}
                            </Text>
                          </FormControl>
                          <FormControl isRequired>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              Closing Date
                            </FormLabel>
                            <Controller
                              name='closing_date'
                              control={control}
                              render={({ field }) => (
                                <DatePickerInput
                                  onChange={(value) => field.onChange(value)}
                                  selected={watch('closing_date')}
                                  showTimeSelect
                                  selectsEnd
                                  startDate={watch('posting_date')}
                                  endDate={watch('closing_date')}
                                  minDate={watch('posting_date')}
                                />
                              )}
                            />
                            <Text color='red' fontSize={14} mb='10px' ml='5px'>
                              {errors.closing_date?.message}
                            </Text>
                          </FormControl>
                        </Grid>

                        {/* Row 4: Summary */}
                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Summary
                          </FormLabel>
                          <Editor name='summary' control={control} />
                        </FormControl>

                        {/* Row 5: Description */}
                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Description
                          </FormLabel>
                          <Editor name='description' control={control} />
                        </FormControl>

                        {/* Row 6: Responsibilities */}
                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Responsibilities
                          </FormLabel>
                          <Editor name='responsibilities' control={control} />
                        </FormControl>

                        {/* Row 7: Requirements */}
                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Requirements
                          </FormLabel>
                          <Editor name='requirements' control={control} />
                        </FormControl>
                      </TabPanel>

                      {/* Vietnamese Tab */}
                      <TabPanel>
                        <FormControl mt={2}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Position
                          </FormLabel>
                          <Input
                            fontSize='sm'
                            ms='4px'
                            type='text'
                            placeholder='Vị trí'
                            maxLength={250}
                            size='md'
                            name='position_vn'
                            {...register('position_vn')}
                          />
                        </FormControl>

                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            File
                            {previewImageVN && (
                              <Text as='span' fontSize='xs' color='blue.500' ml={2}>
                                <a
                                  href={previewImageVN}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{ textDecoration: 'underline' }}
                                >
                                  (View current file)
                                </a>
                                {' | '}
                                <Text
                                  as='span'
                                  color='red.500'
                                  cursor='pointer'
                                  textDecoration='underline'
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setPreviewImageVN('');
                                    setValue('file_url_vn', null);
                                  }}
                                >
                                  Remove
                                </Text>
                              </Text>
                            )}
                          </FormLabel>
                          <Input
                            fontSize='sm'
                            ms='4px'
                            type='file'
                            placeholder='File'
                            size='sm'
                            name='file_url_vn'
                            {...register('file_url_vn')}
                          />
                        </FormControl>

                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Summary
                          </FormLabel>
                          <Editor name='summary_vn' control={control} />
                        </FormControl>

                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Description
                          </FormLabel>
                          <Editor name='description_vn' control={control} />
                        </FormControl>

                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Responsibilities
                          </FormLabel>
                          <Editor name='responsibilities_vn' control={control} />
                        </FormControl>

                        <FormControl mt={3}>
                          <FormLabel
                            color={textColor}
                            fontWeight='bold'
                            fontSize='xs'
                          >
                            Requirements
                          </FormLabel>
                          <Editor name='requirements_vn' control={control} />
                        </FormControl>
                      </TabPanel>
                    </TabPanels>
                  </Tabs>

                  {/* Active Switch (outside tabs) */}
                  <FormControl mt={3}>
                    <Controller
                      name='isActive'
                      control={control}
                      defaultValue={true}
                      render={({ field: { onChange, value } }) => (
                        <Switch
                          id='isChecked'
                          isChecked={value}
                          onChange={onChange}
                          size='md'
                          ms='4px'
                        >
                          Active
                        </Switch>
                      )}
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}
                  >
                    {isCreate ? 'Create' : 'Update'}
                  </Button>
                  <Button
                    onClick={() => {
                      onClose();
                      reset();
                      setPreviewImage('');
                      setPreviewImageVN('');
                      setLanguageIds({});
                    }}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <SearchTable2
          tableData={newListNews}
          columnsData={columnsDataRecruitment}
          totalRow={totalRows.recruitments || 0}
          edit={editNews}
          actionsActive={['edit']}
          listPermissions={[43]}
          isFetching={isFetching}
          loadData={(fetchDataOptions) => recallApi(fetchDataOptions, false)}
          refreshPagingDefault={refreshPagingDefault}
        />
      </CardBody>
    </Card>
  );
}

export default DataTableRecruitment;
